import { Component, OnInit, OnDestroy, Input, ChangeDetectionStrategy } from '@angular/core'

import { Subject } from 'rxjs'

import { Order, OrderVehicle } from '@app/shared/models'
import { RedirectService } from '@app/shared'

@Component({
    selector: 'app-candidate-item-history',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './candidate-item-history.component.html',
    standalone: false
})
export class CandidateItemHistoryComponent implements OnInit, OnDestroy {


  destroyed$ = new Subject<boolean>()
  _candidate
  devView = false
  // Routes carry the session's userIndex (/#/2/recruiter/...); linking back without it drops
  // the multi-tenant session
  userIndex = '0'
  @Input()
  set candidate(val) {
    if(val){
        this._candidate = val
    }
  }


  constructor(private redirectService: RedirectService) { }

  ngOnInit() {
    this.userIndex = this.redirectService.getUrlIndex()
  }

  ngOnDestroy() {
    this.destroyed$.next(true)
    this.destroyed$.complete()
  }
}
